import { useContext, useState, useEffect } from "react";
import {
  StartContainer,
  ImageSvgRes,
  ImageHeader,
} from "../../styles/Screens/Welcome";
import { Text, Title } from "../../styles/Texts";
import { T } from "../../styles/Theme";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
// import ReactGA from "react-ga4";
import { ADVISER_IDENTIFIER, QUESTIONS_API_URL } from "../../env";
import { GenericButton } from "../../components/UI-KIT/GenereicButton";
import { EssentialsDataContext } from "../../Contexts/EssentialsDataContext";
import { DataInitialSetup } from "../../Interfaces/IInitialSetup";
import TextValues from "../../TextValues/index.json";
import styled from "styled-components";
import { uploadEventRequest } from "../../utils/requests";

export const Welcome = () => {
  const [, , screenNumber, setScreenNumber] = useContext(EssentialsDataContext);

  const sendEvent = () => {
    const code: string = `${ADVISER_IDENTIFIER}[3r8h383@98hf3.artebianca]`;
    const body: any = JSON.stringify({
      data: {eventName: "next", tag: "P0", content: "Quiero comenzar"}
    });
    uploadEventRequest(body, code).then((res) => void(0));
  };

  const handleStart = () => {
    setScreenNumber(screenNumber + 1);
    sendEvent();
  };

  const [settings, setSettings] = useState<DataInitialSetup | null>(null);

  useEffect(() => {
    const url = `${QUESTIONS_API_URL}/${ADVISER_IDENTIFIER}/settings/`;
    axios.get(url).then((res) => setSettings(res.data.data[0]));
  }, []);

  return (
    <StartContainer>
      <ImageSvgRes>
        <ImageHeader />
      </ImageSvgRes>
      
      {/* <TitleContainer>
        <Title>
          <TextDescriptionConatiner>
            {settings ? settings.title : <Skeleton />}
          </TextDescriptionConatiner>
          </Title>
      </TitleContainer> */}
      <DescriptionContainer>
          <TextTitleConatiner>
            {settings ? (
              <>
              En <span className="bold">Escuela Internacional Artebianca</span> somos tu aliado estratégico en la formación y capacitación de
              panadería, pastelería y gastronomía.
              </>
            ) : <Skeleton count={4} />}
          </TextTitleConatiner>  
      </DescriptionContainer>

      <div className="buttonContainer">
        <ButtonStyled onClick={handleStart}>
          {TextValues.buttons.initialSetup}
          </ButtonStyled>
      </div>
    </StartContainer>
  );
};


const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;

  margin-top: 30px;
  margin-bottom: 20px;
  margin-left: 50px;
  margin-right: 50px;

  @media(max-width: 480px) {
    margin-right: 20px;
    margin-left: 20px;
  }
`;

// const DescriptionContainer = styled.div`
//   margin-right: 50px;
//   margin-left: 50px;
//   dipplay: flex;
//   align-items: center;
//   justify-content: center;
//   align-content: center;

//   @media(max-width: 480px) {
//     margin-right: 20px;
//     margin-left: 20px;
//   }
// `;

// const TextTitleConatiner = styled.p`
//   font-weight: bold;
//   @media(max-width: 480px) {
//     font-size: ${T.fontSizes.large};
//   }
// `;

const DescriptionContainer = styled.div`
  margin-right: 80px;
  margin-left: 80px;
  display: flex;
  margin-top: 20px;
  margin-bottom: 20px;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 23px;
  line-height: 1.3;
  font-family: 'Oswald', sans-serif;
  font-weight: 400;

  .bold {
    font-weight: 700;
    font-family: 'Oswald', sans-serif;
  }

  @media (max-width: 480px) {
    margin-right: 20px;
    margin-left: 20px;
  }
`;

const TextTitleConatiner = styled.p`
  font-style: italic;
  font-family: 'Oswald', sans-serif;
  font-weight: 400;

  span {
    font-weight: 700;
    font-family: 'Oswald', sans-serif;
  }
  
  @media (max-width: 480px) {
    font-size: ${T.fontSizes.large};
  }
`;


const TextDescriptionConatiner = styled.p`
  font-weight: bold;
  @media(max-width: 480px) {
    font-weight: ${T.fontWeights.bold};
  }
`;

const ButtonStyled = styled.div`
  background-color: #F8C11A;
  border: none;
  color: black;
  padding: 15px 30px;
  text-align: center;
  width: 100%;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  font-weight: 400;
  border-radius: 50px; /* Bordes más redondeados */
  box-shadow: inset 0px 2px 3px rgba(255, 255, 255, 0.5), /* Sombra interna brillante */
              inset 0px -2px 3px rgba(0, 0, 0, 0.3), /* Sombra interna oscura */
              0px 5px 10px rgba(0, 0, 0, 0.5); /* Sombra externa */
  cursor: pointer;
  user-select: none;

  &:hover {
    background-color: #D9A514;
    box-shadow: inset 0px 2px 3px rgba(255, 255, 255, 0.5), 
                inset 0px -2px 3px rgba(0, 0, 0, 0.4),
                0px 6px 12px rgba(0, 0, 0, 0.5);
  }
  // font-style: italic;
  font-family: 'Big John', sans-serif;
              
  &:active {
    transform: scale(0.95);
  }
`;
